export default function ProcessList({ steps }) {
  return (
    <div className="process-list">
      {steps.map((step, index) => (
        <div key={step} className="process-step">
          <div className="process-step__number">{String(index + 1).padStart(2, '0')}</div>
          <p>{step}</p>
        </div>
      ))}
    </div>
  );
}
